import apiClient from './apiClient';

const client = apiClient('promos/blockchain');

const blockchainApi = {
    getConfig: () => client.get('/config'),
    getPromoBlockchainInfo: (promoId) => client.get(`/${promoId}`),
    signClaim: (data) => client.post('/sign-claim', data),
    // Разрешение на депозит (защита от занятия чужого promoId). Возвращает
    // { signature, amount, endTime } — передавать в deposit() как есть, иначе
    // подпись не сойдётся и контракт отклонит транзакцию.
    signDeposit: (data) => client.post('/sign-deposit', data).then((r) => r.data),
    // История пополнений/выводов текущего юзера — { items, total }
    getMyHistory: () => client.get('/my-history').then((r) => r.data),
    notifyDeposited: (data) => client.post('/deposited', data),
    notifyFeePaid: (data) => client.post('/fee-paid', data),
    notifyClaimed: (data) => client.post('/claimed', data),
    notifyWithdrawn: (data) => client.post('/withdrawn', data),
};

export default blockchainApi;
